var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container "},[_c('div',[_c('h4',{staticClass:"animated fadeInUp title"},[_vm._v("Recent Projects ")]),_c('Project',{staticClass:"animated fadeInUp"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }